import { Container, Grid, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import TextField from '../../components/Form/TextField';
import { useAuth } from '../../hooks/auth';
import getValidationErrors from '../../utils/getValidationErrors';
import useStyles from './styles';
interface user {
    userName: string,
    password: string
}

const SignIn: React.FC = () => {
    const { t } = useTranslation("SignIn");
    const { signIn } = useAuth();

    const classes = useStyles();
    const [loading, setLoading] = React.useState(false);
    const { handleSubmit, control } = useForm<user>(
        {
            defaultValues: {
                userName: '',
                password: ''
            }
    })
    const onSubmit = async (data: any) => {
        try {

            const schema = Yup.object().shape({
                userName: Yup.string().required(t("userIsMandatory")),
                password: Yup.string().required(t("passwordIsMandatory")),
            });

            await schema.validate(data, {
                abortEarly: false,
            });
            setLoading(true);
            await signIn({ userName: data.userName, password: data.password });
            setLoading(false);
        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const errors = getValidationErrors(err);
                alert(errors);
                return;
            }

            setLoading(false);
        }
    };

    return (
        <div className={classes.root} >
            <Container className={classes.container} component="main" maxWidth="xs">
                <div className={classes.paper}>
                    <img style={{ paddingTop: '22px' }} src="./img/logo.png" alt="" />
                    <Typography color="primary" style={{ paddingTop: '50px' }} component="h1" variant="h5">
                        Logar na conta
                    </Typography>
                    
                    <form onSubmit={handleSubmit(onSubmit)} >
                            <Grid item xs={12}>
                                <TextField 
                                    label={"Login"} 
                                    name="userName" 
                                    autoFocus
                                    className={classes.textField}
                                    style={{ margin: '0px', marginBottom: '22px' }}
                                    control={control} 
                                    fullWidth
                                />                                
                            </Grid>
                            <Grid item xs={12}>
                                <TextField 
                                    label={t('Password')} 
                                    name="password" 
                                    type="password"
                                    autoComplete="current-password"
                                    autoFocus
                                    className={classes.textField}
                                    style={{ margin: '0px', marginBottom: '22px' }}
                                    control={control} 
                                    fullWidth
                                />                                
                            </Grid>
        
                        {loading ?
                            <CircularProgress />
                            :
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                type="submit"
                            >
                                Logar
                            </Button>
                        }
                    </form>
                </div>
            </Container>
        </div>

    );
}

export default SignIn;
